import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
/**
 * @function useProductPropertiesAttributes
 * @description Hook to handle product properties attributes for beauty and wellness.
 * @returns {Object} An object containing the function to get the final attribute string.
 */
export function useProductPropertiesAttributes() {
  var _useNuxt2App = useNuxt2App(),
    locale = _useNuxt2App.i18n.locale;

  /**
   * Get the first two elements of an array.
   *
   * @param {Attribute[]} attributesArray - The array from which to extract the elements.
   * @returns {Attribute[]} - A new array containing the first two elements of the input array, or an empty array if the input array is empty or undefined.
   */
  function getFirstTwoAttributes(attributesArray) {
    var _attributesArray$slic;
    return (_attributesArray$slic = attributesArray === null || attributesArray === void 0 ? void 0 : attributesArray.slice(0, 2)) !== null && _attributesArray$slic !== void 0 ? _attributesArray$slic : [];
  }

  /**
   * Get the final attribute string based on beauty and wellness attributes.
   *
   * @param {Attribute[]} beauty - Array of beauty attributes.
   * @param {Attribute[]} wellness - Array of wellness attributes.
   * @returns {string} - The final attribute string.
   */
  function getFinalAttributeString() {
    var _ref, _beautyAttributes$0$l3, _beautyAttributes$4, _wellnessAttributes$7;
    var beauty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var wellness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var beautyAttributes = getFirstTwoAttributes(beauty);
    var wellnessAttributes = getFirstTwoAttributes(wellness);
    if (beautyAttributes.length > 0 && wellnessAttributes.length > 0) {
      var _beautyAttributes$0$l, _beautyAttributes$, _wellnessAttributes$, _wellnessAttributes$2;
      return "".concat((_beautyAttributes$0$l = (_beautyAttributes$ = beautyAttributes[0]) === null || _beautyAttributes$ === void 0 ? void 0 : _beautyAttributes$.label[locale]) !== null && _beautyAttributes$0$l !== void 0 ? _beautyAttributes$0$l : '', " \u2022 ").concat((_wellnessAttributes$ = (_wellnessAttributes$2 = wellnessAttributes[0]) === null || _wellnessAttributes$2 === void 0 ? void 0 : _wellnessAttributes$2.label[locale]) !== null && _wellnessAttributes$ !== void 0 ? _wellnessAttributes$ : '');
    }
    if (beautyAttributes.length > 1) {
      var _beautyAttributes$0$l2, _beautyAttributes$2, _beautyAttributes$1$l, _beautyAttributes$3;
      return "".concat((_beautyAttributes$0$l2 = (_beautyAttributes$2 = beautyAttributes[0]) === null || _beautyAttributes$2 === void 0 ? void 0 : _beautyAttributes$2.label[locale]) !== null && _beautyAttributes$0$l2 !== void 0 ? _beautyAttributes$0$l2 : '', " \u2022 ").concat((_beautyAttributes$1$l = (_beautyAttributes$3 = beautyAttributes[1]) === null || _beautyAttributes$3 === void 0 ? void 0 : _beautyAttributes$3.label[locale]) !== null && _beautyAttributes$1$l !== void 0 ? _beautyAttributes$1$l : '');
    }
    if (wellnessAttributes.length > 1) {
      var _wellnessAttributes$3, _wellnessAttributes$4, _wellnessAttributes$5, _wellnessAttributes$6;
      return "".concat((_wellnessAttributes$3 = (_wellnessAttributes$4 = wellnessAttributes[0]) === null || _wellnessAttributes$4 === void 0 ? void 0 : _wellnessAttributes$4.label[locale]) !== null && _wellnessAttributes$3 !== void 0 ? _wellnessAttributes$3 : '', " \u2022 ").concat((_wellnessAttributes$5 = (_wellnessAttributes$6 = wellnessAttributes[1]) === null || _wellnessAttributes$6 === void 0 ? void 0 : _wellnessAttributes$6.label[locale]) !== null && _wellnessAttributes$5 !== void 0 ? _wellnessAttributes$5 : '');
    }
    return (_ref = (_beautyAttributes$0$l3 = (_beautyAttributes$4 = beautyAttributes[0]) === null || _beautyAttributes$4 === void 0 ? void 0 : _beautyAttributes$4.label[locale]) !== null && _beautyAttributes$0$l3 !== void 0 ? _beautyAttributes$0$l3 : (_wellnessAttributes$7 = wellnessAttributes[0]) === null || _wellnessAttributes$7 === void 0 ? void 0 : _wellnessAttributes$7.label[locale]) !== null && _ref !== void 0 ? _ref : '';
  }
  return {
    getFinalAttributeString: getFinalAttributeString
  };
}